import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityActionTemplatesSlice } from './get';
import { postCoreDataSecurityActionTemplateSlice } from './post';

import { coreDataSecurityActionTemplateByIdReducers, coreDataSecurityActionTemplateByIdWatchers } from './_id';
import { coreDataSecurityActionTemplateByUrlReducers, coreDataSecurityActionTemplateByUrlWatchers } from './_url';

export const coreDataSecurityActionTemplatesReducers = combineReducers({
	byId: coreDataSecurityActionTemplateByIdReducers,
	byUrl: coreDataSecurityActionTemplateByUrlReducers,
	get: getCoreDataSecurityActionTemplatesSlice.asyncReducers,
	post: postCoreDataSecurityActionTemplateSlice.asyncReducers
});

export const coreDataSecurityActionTemplatesWatchers = combineAllWatchers([
	coreDataSecurityActionTemplateByIdWatchers,
	coreDataSecurityActionTemplateByUrlWatchers,
	getCoreDataSecurityActionTemplatesSlice.asyncWatchers,
	postCoreDataSecurityActionTemplateSlice.asyncWatchers
]);
